<template>
  <input v-model="checkValue" type="checkbox" :disabled="disabled"/>
</template>
<script lang="ts">
import { computed, defineComponent, ref, toRefs } from "vue";

export default defineComponent({
  name: "YNCheckboxRenderer",
  setup(props: any) {
    const { params } = toRefs(props);

    const disabled = ref<boolean>(!params.value.column.colDef.editable);

    const checkValue = computed({
      get: () => {
        return params.value.value === "Y";
      },
      set: (v) => {
        params.value.node.setDataValue(params.value.column.colId, v ? "Y" : "N");
      },
    });
    return {
      checkValue,
      disabled,
    };
  },
});
</script>
